import { useCallback, useContext, useMemo } from 'react';
import { useCookies } from 'react-cookie';
import { UserContext } from '../../context';
import { getCommentsFeed, loadMoreCommentsFeed } from '../../slices';
import { COMMENTS_FEED_ADMIN_COOKIE_KEY } from '../constants';
import { OrderDirection } from '../models';
import { useAppDispatch } from './useAppDispatch';
import { useAppSelector } from './useAppSelector';
import { useLastDate } from './useLastDate';

export const useCommentsFeed = () => {
  const dispatch = useAppDispatch();

  const { getDateRange } = useLastDate();

  const [cookies] = useCookies([COMMENTS_FEED_ADMIN_COOKIE_KEY]);

  const { channelId } = useContext(UserContext).userInfo.userData;

  const { page } = useAppSelector(({ commentsFeed }) => commentsFeed);

  const { requestFilter = { orderDirection: OrderDirection.DESC } } = {
    ...cookies[COMMENTS_FEED_ADMIN_COOKIE_KEY],
  };

  const { dateRange, orderDirection, ...requestFilterRest } = requestFilter;

  const filters = useMemo(() => {
    return { ...requestFilterRest, ...getDateRange(dateRange) };
  }, [dateRange, getDateRange, requestFilterRest]);

  const getCommentsFeedItems = useCallback(
    () => dispatch(getCommentsFeed({ channelId, orderDirection, filters })),
    [channelId, dispatch, filters, orderDirection]
  );

  const loadMoreCommentsFeedItems = useCallback(
    () => dispatch(loadMoreCommentsFeed({ channelId, orderDirection, page: page + 1, filters })),
    [channelId, dispatch, filters, orderDirection, page]
  );

  return { getCommentsFeedItems, loadMoreCommentsFeedItems };
};
